import React, { Component } from 'react'
import i18n from 'i18n-js';

interface MyProps {
  name?: any;
  setStateValue?: any;
  form?: any;
  placeholder?: any;
  required?: boolean;
  label?: string;
  value?: string;
  optionList?: [];
  options?: any;
  type?: any;
  min?: any;
  max?: any;
  onChange?: any;
}

interface MyState {}

class CommonInputValidation extends Component<MyProps, MyState> {
  constructor(props: Readonly<MyProps>) {
    super(props);

    this.validateInput = this.validateInput.bind(this);
  }

  componentWillMount() {
    const { label = '', value, name, setStateValue, form, required = false } = this.props;
    const arr = [];
    arr[name] = {
      value: value || "",
      label,
      name,
      errorMessage: "",
      required,
    };

    setStateValue({ form: Object.assign(form, arr) });
  }

  validateInput(e: any) {
    const { label = '', name, setStateValue, form, required } = this.props;
    const arr = [];
    const tartgetValue = e.target.value;

    let errorMessage = '';
    if (required && !tartgetValue) {
      errorMessage = `${label} Skal udfyldes`;
    }

    arr[name] =
      {
        value: tartgetValue,
        label,
        name,
        errorMessage,
        required
      };

    setStateValue({ form: Object.assign(form, arr) });
  }

  render() {
    const { label = '', value, name, form, placeholder, required = false, optionList, options, type, onChange, min, max } = this.props;

    return (
      <div className="box-input-validate">
        {
          label ?
            <p>{label} {required ? <span className="require">*</span> : null}</p>
            : null
        }

        {
          optionList && options ?
            <div>
              <select onChange={this.validateInput}>
                <option value="">{i18n.t('select')}</option>
                {
                  optionList.map((val: any, key: any) => {
                    return <option value={val[options.value]} key={key}>{val[options.display]}</option>
                  })
                }
              </select>
            </div>
            : null
        }

        {
          (!type && !optionList && !options) || (type === 'text' && !optionList && !options) ?
            <input defaultValue={value} type={type || 'text'} onDrop={(e: any) => {e.preventDefault()}} placeholder={placeholder} onKeyUp={this.validateInput}/>
            : null
        }
        {
          type === 'date' && !optionList && !options ?
            <input defaultValue={value} type={type} onDrop={(e: any) => {e.preventDefault()}} placeholder={placeholder} onChange={this.validateInput}/>
            : null
        }
        {
          form && form[name] && form[name].errorMessage ?
            <p className="require pd-top-5">{form[name].errorMessage}</p>
            : null
        }
      </div>
    )
  }
}

export default CommonInputValidation;
